import {AnyAction} from 'redux';
import {
  SET_LOAD,
  CHANGE_THEME,
  SET_ALERT,
  SET_TERMS_MODAL_VISIBLE,
  SET_PRIVACY_MODAL_VISIBLE,
} from '../actionTypes';

export const setLoadingSuccess = (payload = {}) => ({
  type: SET_LOAD,
  payload,
});

export const changeThemeSuccess = (payload = {}) => ({
  type: CHANGE_THEME,
  payload,
});

export const setAlertSuccess = (payload = {}) => ({
  type: SET_ALERT,
  payload,
});

export const setTermsModalSuccess = (payload = {}) => ({
  type: SET_TERMS_MODAL_VISIBLE,
  payload,
});

export const setPrivacyModalSuccess = (payload = {}) => ({
  type: SET_PRIVACY_MODAL_VISIBLE,
  payload,
});

export const setLoading = ({value}: {value: boolean}) => {
  return (dispatch: (action: AnyAction) => void) => {
    dispatch(setLoadingSuccess({loading: value}));
  };
};

export const changeTheme = ({value}: {value: boolean}) => {
  return (dispatch: (action: AnyAction) => void) => {
    dispatch(changeThemeSuccess({theme: value}));
  };
};

export const setAlert = (props?: {
  message: string;
  title: string;
  callback?: () => void;
}) => {
  return (dispatch: (action: any) => void) => {
    dispatch(setAlertSuccess({alert: props || null}));
  };
};

export const setTermsModalVisible = ({visible}: {visible: boolean}) => {
  return (dispatch: (action: any) => void) => {
    dispatch(setTermsModalSuccess({termsModalVisible: visible}));
  };
};

export const setPrivacyModalVisible = ({visible}: {visible: boolean}) => {
  return (dispatch: (action: any) => void) => {
    dispatch(setPrivacyModalSuccess({privacyModalVisible: visible}));
  };
};
